import React from "react";
import "./Header.scss";
import { motion } from "framer-motion";
import { AppWrap } from "../../wrapper";
import { images } from "../../constants";
import background from "../../assets/background.mp4";
import backgroundOne from "../../assets/backgroundOne.jpg";


const scaleVariants = {
  whileInView: {
    scale: [0, 1],
    opacity: [0, 1],
    transition: {
      duration: 1,
      ease: "easeInOut",
    },
  },
};
const Header = () => {
  return (
    <>
      <video src={background} autoPlay loop muted />
      <img src={backgroundOne} alt='bg-pic' className="header-background"/>

      <div className="app__header app__flex">
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
          className="app__header-info"
        >
          <div className="app__header-badge">
            <div className="badge-cmp app__flex">
              <span>👋</span>
              <div style={{ marginLeft: 20 }}>
                <p className="p-text">Hello I Am</p>
                <h1 className="head-text">Martins Pelumi</h1>
              </div>
            </div>
            <div className="tag-cmp app__flex">
              <p>Front End</p>
              <p>Web Developer</p>
            </div>
          </div>
        </motion.div>

        <motion.div
          variants={scaleVariants}
          whileInView={scaleVariants.whileInView}
          className="app__header-circles"
        >
          {[images.react, images.html, images.css, images.sass].map(
            (circle, index) => (
              <div className="circle-cmp app__flex" key={`circle-${index}`}>
                <img src={circle} alt="circle" />
              </div>
            )
          )}
        </motion.div>
      </div>
    </>
  );
};

export default AppWrap(Header, "home");
